<ng-template [ngIf]="objetivoSelect">
  <mat-toolbar class="dialog-title">
    <span>{{data.abrirDesdeMenu?objetivoSelect.configuracionPlan.nombre:titulo}}</span>
    <div (click)="cerrar()" class="close-dialog">
      <i class="fas fa-times"></i>
    </div>
  </mat-toolbar>

  <div mat-dialog-content>
    <ng-template [ngIf]="objetivosMultiLevelList.length>0">

      <div *ngFor="let confPlan of objetivosMultiLevelList;let i = index">
        <mat-form-field appearance="outline" style="display: block; ">
          <mat-label>{{confPlan.nombre}}</mat-label>
          <mat-select (selectionChange)="seleccionarObjetivo($event,i)">
            <mat-option></mat-option>
            <mat-option *ngFor="let objetivo of confPlan.objetivos" [value]="objetivo">
              {{objetivo.nombre}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-template>

    <mat-form-field appearance="outline">
      <mat-label>Nombre<span style="color: red;">*</span> </mat-label>
      <input matInput [(ngModel)]="objetivoSelect.nombre">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Descripción <span style="color: red;">*</span></mat-label>
      <textarea matInput [(ngModel)]="objetivoSelect.descripcion" matTextareaAutosize matAutosizeMinRows=7 matAutosizeMaxRows=21></textarea>
    </mat-form-field>
    <div class="dialog-buttons">
      <button mat-raised-button class="btn_olive" [disabled]="!verificarCampos()" (click)="guardar()">Registrar</button>&nbsp;
      <button mat-raised-button class="btn_danger" (click)="cerrar()">Cancelar</button>
    </div>
  </div>
</ng-template>
